import React, { useContext } from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import Dropdown from 'components/Tailwind/Components/Dropdown';
import { StyleContext } from 'utils/context/StyleContextProvider';

export default function BlogHead({
    title,
    subText,
    categories,
    category = {},
    isTop = false,
}) {
    const styles = useContext(StyleContext),
        categoryTitle = category.title;

    let blogTitle = title;
    if (categoryTitle) {
        if (categoryTitle === 'Most Recent') {
            blogTitle = categoryTitle;
        } else {
            blogTitle = `Category: ${categoryTitle}`;
        }
    }

    return (
        <section
            className={classNames(
                styles.blog__Header,
                'py-10 lg:grid lg:items-end lg:gap-20 lg:py-20',
                categories
                    ? `${styles.category} lg:grid-cols-2`
                    : `${styles.noSearch} lg:grid-cols-3`,
            )}
        >
            <div className={styles.body}>
                {categories ? (
                    <>
                        {isTop && (
                            <p
                                className={classNames(
                                    'heading-6',
                                    styles.top__title,
                                )}
                            >
                                Viome Research Blog
                            </p>
                        )}
                        <h1 className="heading-1">
                            {blogTitle || 'Recent Articles'}
                        </h1>
                    </>
                ) : (
                    <>
                        <Link href="/blog">
                            <h1>{blogTitle}</h1>
                        </Link>
                        <br />
                        <h6>{subText}</h6>
                    </>
                )}
            </div>
            <div className={styles.ui_container}>
                {categories && (
                    <Dropdown
                        name="Categories"
                        items={categories}
                        path="/blog/category/"
                        active={categoryTitle}
                    />
                )}
            </div>
        </section>
    );
}
